import { render, staticRenderFns } from "./createBackupOrder.vue?vue&type=template&id=9f654f12&scoped=true"
import script from "./createBackupOrder.vue?vue&type=script&lang=js"
export * from "./createBackupOrder.vue?vue&type=script&lang=js"
import style0 from "./createBackupOrder.vue?vue&type=style&index=0&id=9f654f12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f654f12",
  null
  
)

export default component.exports